import { datadogRum } from '@datadog/browser-rum-slim'

const TRIBES = {
  Engage: 'engage',
  Fulfilment: 'fulfilment',
  Pricing: 'pricing',
  Wordpress: 'wordpress',
  Unknown: 'unknown',
}

const TEAMS = {
  Journey: 'journey',
  Wordpress: 'wordpress',
  OrderExperience: 'order-experience',
  Voucher: 'voucher',
  Cart: 'cart',
  Dynamic: 'dynamic',
  Unknown: 'unknown',
}

const TEAM_TRIBE_MAP = {
  [TEAMS.Journey]: TRIBES.Engage,
  [TEAMS.Dynamic]: TRIBES.Engage,
  [TEAMS.Wordpress]: TRIBES.Wordpress,
  [TEAMS.OrderExperience]: TRIBES.Fulfilment,
  [TEAMS.Voucher]: TRIBES.Pricing,
  [TEAMS.Cart]: TRIBES.Pricing,
  [TEAMS.Unknown]: TRIBES.Unknown,
}

const ROUTE_GROUPS = {
  [TEAMS.Journey]: [
    '/recipes',
    '/product-listing',
    '/product',
    '/search',
    '/recipeSearch',
    '/categories',
    '/category',
    '/brands',
    '/brand',
    '/tag',
    '/accounts',
    '/shoppinglist',
    '/promotions',
    '/weekly-promotions',
    '/swa',
    '/store-locator',
    '/loyalty/programmes/jwc',
    '/loyalty/memberships/pay',
    '/membership/registration',
    '/membership/linkage',
    '/membership/checkout',
    '/membership/welcome',
    '/page',
    '/external',
    '/redirect',
    '/review',
    '/store-locator',
    '/page',
  ],
  [TEAMS.Dynamic]: [
    '/loyalty/programmes/jwc',
    '/loyalty/memberships/pay',
    '/membership/registration',
    '/membership/linkage',
    '/membership/checkout',
    '/membership/welcome',
  ],
  [TEAMS.Wordpress]: ['/blog'],
  [TEAMS.Cart]: ['/cart', '/checkout'],
  [TEAMS.Voucher]: ['/voucher', '/vouchers'],
  [TEAMS.OrderExperience]: ['/order', '/orders', '/order-summary'],
}

const createTeamConfig = team => ({
  team,
  tribe: TEAM_TRIBE_MAP[team],
})

const TEAM_ROUTING_CONFIG = (() => {
  const config = {}

  Object.entries(ROUTE_GROUPS).forEach(([team, routes]) => {
    routes.forEach(route => {
      config[route] = createTeamConfig(team)
    })
  })

  return config
})()

export const getTeamForRoute = path => {
  if (path === '/') {
    return createTeamConfig(TEAMS.Journey)
  }

  const matchingRoute = Object.keys(TEAM_ROUTING_CONFIG).find(route => {
    if (path === route) {
      return true
    }

    return path.startsWith(route)
  })
  const defaultTeam = createTeamConfig(TEAMS.Unknown)

  return matchingRoute ? TEAM_ROUTING_CONFIG[matchingRoute] : defaultTeam
}

export const setTeamTagForPath = path => {
  const team = getTeamForRoute(path)
  datadogRum.setGlobalContextProperty('team', team.team)
  datadogRum.setGlobalContextProperty('tribe', team.tribe)
}
